(
    function (skyward, $, undefined)
    {
        skyward.courserequest = skyward.courserequest || {};

        var availableCoursesContains = '#AvailableCoursesContains';
        var maximumCredits = '.js-onlineRequestsMaximumCredits';
        var maximumAlternateCredits = '.js-onlineRequestsMaximumAlternateCredits';
        var maximumCourseRequests = '.js-onlineRequestsMaximumCourseRequests';
        var maximumAlternateCourseRequests = '.js-onlineRequestsMaximumAlternateCourseRequests';
        var totalEarnedCredits = '.js-onlineRequestsTotalEarnedCredits';
        var totalAlternateEarnedCredits = '.js-onlineRequestsTotalAlternateEarnedCredits';
        var totalRequests = '.js-onlineRequestsTotalRequests';
        var totalAlternateRequests = '.js-onlineRequestsTotalAlternateRequests';

        var availableCoursesBrowseName = 'AvailabilityListCourses';
        var selectedCoursesBrowseName = 'StudentCourseRequestsSelected';
        var alternateCourseBrowseName = 'AlternateStudentCourseRequestsSelected';
        var courseRequestContentAreaName = 'CourseRequestContentArea';
        var alternateReorderName = "AlternateReorder";

        var courseIDName = "CourseID";
        var courseCodeName = "CourseCode";
        var courseDescriptionName = "Description";
        var courseCodeDescriptionName = "CodeDescription";
        var studentCourseRequestIDName = "StudentCourseRequestID";
        var requestSourceCodeName = "RequestSourceCode";
        var requestStatusCodeName = "RequestStatusCode";
        var rankName = "AlternateRank";

        var isAlternateTabName = "Alternates";

        //static should not change once it is set
        var accessMode;
        var entityID;
        var schoolYearID;
        var studentID;
        var entityID_securityhash;
        var schoolYearID_securityhash;
        var studentID_securityhash;
        var availabilityFilterCourseStudentID;
        var availabilityFilterCourseStudentID_securityhash;
        var initialAlternateStudentCourseRequestRank = "";
        var useCourseRequestCountMaximum;
        var useCreditsMaximum;

        //course request lists
        var alternateStudentCourseRequestIDsToRemove = "";
        var alternateStudentCourseRequestIDsToRemoveSecurityHash = "";
        var alternateCourseIDsToAdd = "";
        var alternateCourseIDsToAddSecurityHash = "";
        var alternatesRank = "";

        var studentCourseRequestIDsToRemove = "";
        var studentCourseRequestIDsToRemoveSecurityHash = "";
        var courseIDsToAdd = "";
        var courseIDsToAddSecurityHash = "";

        var isAlternateMode = false;
        var requestContentMessageArea;
        var myRequestsPopupRequestContentMessageArea;
        var submitButton;
        var cancelButton;
        var reorderButton;
        var availableCoursesElement;
        var selectedCoursesElement;
        var alternateCourseElement;

        var previousContainsString = '';

        var reorderElement;
        var reorderColumnWidths = [40, 150, 85]; //as specified in StudentCourseRequestController.GetSortable(), but with Code and
                                                  //Description swapped to match the order they appear in Online Requests browses

        var init = function (selector)
        {
            if (selector == "#" + selectedCoursesBrowseName)
            {
                selectedCoursesElement = $(selector);
                skyward.courserequest.initializeOnlineCourseRequest();
            }

            if (selector == "#" + availableCoursesBrowseName)
            {
                availableCoursesElement = $(selector);
                skyward.courserequest.initializeOnlineCourseRequest();
            }

            if (selector == "#" + alternateCourseBrowseName)
            {
                alternateCourseElement = $(selector);
                skyward.courserequest.initializeOnlineCourseRequest();
            }

            if (selector == "#" + alternateReorderName)
            {
                reorderElement = $(selector);
            }
        };

        var browseInitialLoad = true;
        var browseRowChanged = function (browse)
        {
            if (!browse || !browse.body || !browse.body.find)
            {
                return;
            }
            browse.body.find(".browseRow.current .button").focus();
        };

        //initialization functions
        var initBrowseSearchControls = function ()
        {
            $("#SearchDiv").find('.courseRequestBrowseSearch').each(function ()
            {
                var browseSearch = $(this);
                var browseSearchBox = browseSearch.children('.courseRequestSearchTextbox');

                browseSearchBox.focus(function ()
                {
                    browseSearch.addClass('simulateFocus');
                });

                browseSearch.focusout(function ()
                {
                    browseSearch.removeClass('simulateFocus');
                });
            });
        };

        var initTabButtonHandlers = function ()
        {
            $("#RequestedCourseWrapper").on("tabClicked", ".js-tabbedContainerButton", tabClickHandler);
        };

        var generateCourseFilter = function ()
        {
            skyward.courserequest.generateCourseFilter();
        };

        var mainSelectedBrowseUpdated = function ()
        {
            var mainSelectedBrowseClassName = "mainSelectedBrowse";
            if (alternateCourseElement)
            {
                alternateCourseElement.addClass(mainSelectedBrowseClassName);
            }

            if (selectedCoursesElement)
            {
                selectedCoursesElement.addClass(mainSelectedBrowseClassName);
            }

            if (availableCoursesElement)
            {
                availableCoursesElement.addClass(mainSelectedBrowseClassName);
            }
        };

        var initializationComplete = false;
        skyward.courserequest.initializeOnlineCourseRequest = function ()
        {
            if (initializationComplete)
            {
                return;
            }

            initializationComplete = true;
            initializeMode();

            skyward.browse.eventCallbacks.updateActiveBrowseClasses.registerCallback(mainSelectedBrowseUpdated);

            var body = $("body");
            body.off("browseLoaded." + selectedCoursesBrowseName).on("browseLoaded." + selectedCoursesBrowseName, function ()
            {
                mainSelectedBrowseUpdated();
            });
            body.off("browseLoaded." + availableCoursesBrowseName).on("browseLoaded." + availableCoursesBrowseName, function ()
            {
                mainSelectedBrowseUpdated();
            });
            body.off("browseLoaded." + alternateCourseBrowseName).on("browseLoaded." + alternateCourseBrowseName, function ()
            {
                mainSelectedBrowseUpdated();
            });

            submitButton = $('.js-onlineRequestsSubmit,.js-onlineRequestsSubmitAndReview');
            cancelButton = $('.js-onlineRequestsCancel');

            $("#" + selectedCoursesBrowseName).off("rowChanged").on("rowChanged", function (event, browse)
            {
                browseRowChanged(browse);
            });

            $("#" + availableCoursesBrowseName).off("rowChanged").on("rowChanged", function (event, browse)
            {
                browseRowChanged(browse);
            });

            $("#" + alternateCourseBrowseName).off("rowChanged").on("rowChanged", function (event, browse)
            {
                browseRowChanged(browse);
            });

            skyward.courserequest.setStaticVariables();
            initBrowseSearchControls();
            initTabButtonHandlers();
            requestContentMessageArea = skyward.courserequest.getContentMessageArea($(".js-courserequestcontentmessageareawrapper"));
            myRequestsPopupRequestContentMessageArea = skyward.courserequest.getContentMessageArea($(".js-myrequestspopupcourserequestcontentmessageareawrapper").parent());

            skyward.courserequest.hookupButtonEvents();
            showHideToolBarButtons();
            refreshSelectedBrowseTotals();

            $('.courseRequestSearchTextbox').keydown(skyward.debounce(generateCourseFilter, 600));
            if (!skyward.global.mobileAccess)
            {
                searchFocusAndSelectText();
            }
        };

        var searchFocusAndSelectText = function ()
        {
            $(availableCoursesContains).focus().select();
        };

        var initializeMode = function ()
        {
            reorderButton = $('#ReorderAlternates');
            isAlternateMode = $(".tabButton.current").html() === isAlternateTabName;
            showHideReorderButton();
        };

        skyward.courserequest.hookupButtonEvents = function ()
        {
            $("body").off('click', skyward.courserequest.submitCourseRequest).on('click', ".js-onlineRequestsSubmit", null, skyward.courserequest.submitCourseRequest);
            cancelButton.off('click', skyward.courserequest.cancel).on('click', skyward.courserequest.cancel);
            reorderButton.off('click', skyward.courserequest.reorder).on('click', skyward.courserequest.reorder);
            $("body").off("click", requestCourseRowButtonClick).on("click", ".js-requestCourseAddButton", null, requestCourseRowButtonClick);
            $("body").off("click", removeRequestedCourseRowButtonClick).on("click", ".js-requestCourseRemoveButton", null, removeRequestedCourseRowButtonClick);
            $("body").off("click", showPrimaryAlternatePopupButtonClick).on("click", ".js-requestCoursePrimaryAlternatePopup", null, showPrimaryAlternatePopupButtonClick);
            $("#" + courseRequestContentAreaName).off("click", showMyRequestsButtonClick).on("click", ".js-onlineRequestsViewMyRequests", null, showMyRequestsButtonClick);
            $("#" + courseRequestContentAreaName).off("click", submitAndReviewButtonClick).on("click", ".js-onlineRequestsSubmitAndReview", null, submitAndReviewButtonClick);
        };

        skyward.courserequest.setStaticVariables = function ()
        {
            var courseRequestContainer = $("#" + courseRequestContentAreaName);
            entityID = courseRequestContainer.data('entityid');
            studentID = courseRequestContainer.data('studentid');
            schoolYearID = courseRequestContainer.data('schoolyearid');
            accessMode = courseRequestContainer.data('accessmode');
            entityID_securityhash = courseRequestContainer.data('entityid_securityhash');
            schoolYearID_securityhash = courseRequestContainer.data('schoolyearid_securityhash');
            studentID_securityhash = courseRequestContainer.data('studentid_securityhash');
            availabilityFilterCourseStudentID = courseRequestContainer.data('availabilityfiltercoursestudentid');
            availabilityFilterCourseStudentID_securityhash = courseRequestContainer.data('availabilityfiltercoursestudentid_securityhash');
            updateInitialAlternateRank(JSON.stringify(courseRequestContainer.data('initial-alternate-rank')));
        };

        //button functions
        var requestCourse = function (courseID, courseIDSecurityHash)
        {
            resetMessages();

            if (isNaN(courseID) || courseID == null)
            {
                skyward.courserequest.showError("Please select an Available Course to Add");
                return;
            }

            var maximumCreditsValue = isAlternateMode ? getRequestOrCreditsValue(maximumAlternateCredits) : getRequestOrCreditsValue(maximumCredits);
            var maximumRequestsValue = isAlternateMode ? getRequestOrCreditsValue(maximumAlternateCourseRequests) : getRequestOrCreditsValue(maximumCourseRequests);

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/RequestCourse" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    CourseID: courseID,
                    CourseID_SecurityHash: courseIDSecurityHash,
                    EntityID: entityID,
                    EntityID_SecurityHash: entityID_securityhash,
                    SchoolYearID: schoolYearID,
                    SchoolYearID_SecurityHash: schoolYearID_securityhash,
                    StudentID: studentID,
                    StudentID_SecurityHash: studentID_securityhash,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID,
                    AvailabilityFilterCourseStudentID_SecurityHash: availabilityFilterCourseStudentID_securityhash,
                    StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove,
                    CourseIDsToAdd: courseIDsToAdd,
                    AlternateStudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove,
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    MaximumCredits: maximumCreditsValue,
                    MaximumCourseRequests: maximumRequestsValue,
                    UseCreditsMaximum: useCreditsMaximum,
                    UseCourseRequestCountMaximum: useCourseRequestCountMaximum,
                    IsAlternateMode: isAlternateMode,
                    AlternatesRank: alternatesRank
                },
                success: function (data)
                {
                    postRequestRemoveCourse("RequestCourse", data, courseID, isAlternateMode);
                }
            });
        };

        function getDataFromRow(button)
        {
            var rowId = button.parents("td").data("row");
            var browseName = button.parents(".browse").attr("id");
            var browse = skyward.browse.browseList[browseName];

            if (!browse || rowId === undefined)
            {
                return {};
            }

            var data = {
                CourseID: browse.rowData["CourseID"][rowId],
                CourseIDSecurityHash: browse.rowData["CourseIDSecurityHash"][rowId]
            };

            if (browse.rowData[studentCourseRequestIDName] && browse.rowData["StudentCourseRequestIDSecurityHash"])
            {
                var studentCourseRequestID = browse.rowData[studentCourseRequestIDName][rowId];

                if (studentCourseRequestID !== undefined)
                {
                    data.StudentCourseRequestID = studentCourseRequestID;
                    data.StudentCourseRequestIDSecurityHash = browse.rowData["StudentCourseRequestIDSecurityHash"][rowId];
                }
            }

            var setPropertyIfRowDataPresent = function (rowDataName, propertyToSet)
            {
                if (browse.rowData[rowDataName])
                {
                    data[propertyToSet] = browse.rowData[rowDataName][rowId];
                }
            };

            setPropertyIfRowDataPresent(requestStatusCodeName, "RequestStatus");
            setPropertyIfRowDataPresent(requestSourceCodeName, "RequestSource");

            setPropertyIfRowDataPresent("CodeDescription", "CodeDescription");
            setPropertyIfRowDataPresent("EarnedCredits", "EarnedCredits");
            setPropertyIfRowDataPresent("Subject", "Subject");
            if (browse.rowData["IsAlternate"])
            {
                data["IsAlternate"] = (browse.rowData["IsAlternate"][rowId] || "").toLowerCase() === "true";
            }

            return data;
        }

        var requestCourseRowButtonClick = function ()
        {
            var button = $(this);
            if (!button)
            {
                return;
            }
            var rowData = getDataFromRow(button);
            requestCourse(rowData.CourseID, rowData.CourseIDSecurityHash);
        };

        var postRequestRemoveCourse = function (action, data, courseID, isAlternateMode)
        {
            if (data.warningmessage != "" && data.warningmessage != null && data.warningmessage != "undefined")
            {
                skyward.courserequest.showWarning(data.warningmessage);
            }

            if (data.informationmessage != "" && data.informationmessage != null && data.informationmessage != "undefined")
            {
                skyward.courserequest.showInformation(data.informationmessage);
            }

            if (data.errormessage != "" && data.errormessage != null && data.errormessage != "undefined")
            {
                skyward.courserequest.showError(data.errormessage);
                return;
            }

            updateStudentCourseRequestIDsToRemoveList(data.studentCourseRequestIDsToRemove, data.studentCourseRequestIDsToRemoveSecurityHash);
            updateCourseIDsToAddList(data.courseIDsToAdd, data.courseIDsToAddSecurityHash);

            if (data.totalearnedcredits != "")
            {
                if (isAlternateMode)
                {
                    setRequestOrCreditsText(totalAlternateEarnedCredits, data.totalearnedcredits);
                }
                else
                {
                    setRequestOrCreditsText(totalEarnedCredits, data.totalearnedcredits);
                }
            }

            if (data.totalrequests != "")
            {
                if (isAlternateMode)
                {
                    setRequestOrCreditsText(totalAlternateRequests, data.totalrequests);
                }
                else
                {
                    setRequestOrCreditsText(totalRequests, data.totalrequests);
                }
            }

            var browseData = isAlternateMode ? skyward.browse.browseList[alternateCourseBrowseName].data : skyward.browse.browseList[selectedCoursesBrowseName].data;

            if (action == "RequestCourse")
            {
                browseData.seekId = courseID;
            }

            if (isAlternateMode)
            {
                updateAlternateRank(data.alternatesRank);
                skyward.browse.get(alternateCourseBrowseName, browseData, { CourseIDsToAdd: alternateCourseIDsToAdd, StudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove, AlternatesRank: alternatesRank });
            }
            else
            {
                skyward.browse.get(selectedCoursesBrowseName, browseData, { CourseIDsToAdd: courseIDsToAdd, StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove, AlternatesRank: alternatesRank });
            }

            if (skyward.global.mobileAccess)
            {
                skyward.courserequest.generateCourseFilter(true);
            }

            showHideToolBarButtons();
        };

        var removeRequestedCourse = function (courseID, courseIDSecurityHash, requestID, requestIDSecurityHash, requestSource, requestStatus, codeDescription)
        {
            resetMessages();
            var browse = isAlternateMode ? skyward.browse.browseList[alternateCourseBrowseName] : skyward.browse.browseList[selectedCoursesBrowseName];

            if (isNaN(courseID) || courseID == null)
            {
                skyward.courserequest.showError("Please select a Selected Course to Remove");
                return;
            }

            if (IsScheduled(requestStatus))
            {
                skyward.courserequest.showError("The course " + (codeDescription || getSelectedBrowseRowData(browse, courseCodeDescriptionName)) + " has already been scheduled and cannot be removed");
                return;
            }

            if (IsAddedByOffice(requestSource) || IsAddedByImport(requestSource) || IsAddedByMassProcess(requestSource) || IsAddedByRecommendation(requestSource))
            {
                skyward.courserequest.showError("The request for course " + (codeDescription || getSelectedBrowseRowData(browse, courseCodeDescriptionName)) + " was added by the office and cannot be removed");
                return;
            }

            if (isAlternateMode)
            {
                var alternateRank = getSelectedBrowseRowData(browse, rankName);
            }

            var maximumCreditsValue = isAlternateMode ? skyward.controls.getValue($(maximumAlternateCredits)) : skyward.controls.getValue($(maximumCredits));

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/RemoveRequestedCourse" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    CourseID: courseID,
                    CourseID_SecurityHash: courseIDSecurityHash,
                    EntityID: entityID,
                    EntityID_SecurityHash: entityID_securityhash,
                    SchoolYearID: schoolYearID,
                    SchoolYearID_SecurityHash: schoolYearID_securityhash,
                    StudentID: studentID,
                    StudentID_SecurityHash: studentID_securityhash,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID,
                    AvailabilityFilterCourseStudentID_SecurityHash: availabilityFilterCourseStudentID_securityhash,
                    StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove,
                    CourseIDsToAdd: courseIDsToAdd,
                    AlternateStudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove,
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    StudentCourseRequestID: requestID,
                    StudentCourseRequestID_SecurityHash: requestIDSecurityHash,
                    MaximumCredits: maximumCreditsValue,
                    IsAlternateMode: isAlternateMode,
                    AlternatesRank: alternatesRank,
                    RankToRemove: alternateRank
                },
                success: function (data)
                {
                    postRequestRemoveCourse("RemoveRequestedCourse", data, null, isAlternateMode);
                }
            });
        };

        var removeRequestedCourseRowButtonClick = function ()
        {
            var button = $(this);
            if (!button)
            {
                return;
            }
            var rowData = getDataFromRow(button);

            if (skyward.global.mobileAccess)
            {
                isAlternateMode = rowData.IsAlternate || false;
            }

            removeRequestedCourse(rowData.CourseID, rowData.CourseIDSecurityHash, rowData.StudentCourseRequestID,
                rowData.StudentCourseRequestIDSecurityHash, rowData.RequestSource, rowData.RequestStatus, rowData.CodeDescription);
        };

        var showPrimaryAlternatePopup = function (courseID, courseIDSecurityHash, courseCodeDescription, earnedCredits, subject)
        {
            var contents = $(".js-onlineRequestsPrimaryAlternatePopupContents").children().clone(false);

            contents.find(".js-onlineRequestsPopupCourseCodeDescription").val(courseCodeDescription);
            contents.find(".js-onlineRequestsPopupCourseEarnedCredits").val(earnedCredits);
            contents.find(".js-onlineRequestsPopupSubject").val(subject);
            contents.find(".js-onlineRequestsAddPrimary").click(function ()
            {
                isAlternateMode = false;
                requestCourse(courseID, courseIDSecurityHash);
                dialog.close();
            });
            contents.find(".js-onlineRequestsAddAlternate").click(function ()
            {
                isAlternateMode = true;
                requestCourse(courseID, courseIDSecurityHash);
                dialog.close();
            });

            var dialog = skyward.modalLayer.showDialog("Add Course Request", contents, [{ text: "Close", icon: "Close", click: "close" }]);
        };

        var showPrimaryAlternatePopupButtonClick = function ()
        {
            var button = $(this);
            if (!button)
            {
                return;
            }
            var rowData = getDataFromRow(button);
            return showPrimaryAlternatePopup(rowData.CourseID, rowData.CourseIDSecurityHash, rowData.CodeDescription, rowData.EarnedCredits,
                rowData.Subject);
        };

        var showMyRequestsPopup = function ()
        {
            var hiddenContentContainer = $(".js-myRequestsContent");
            var contents = hiddenContentContainer.children();

            var selectedCoursesPromise = skyward.browse.get(selectedCoursesBrowseName, skyward.browse.browseList[selectedCoursesBrowseName].data, { CourseIDsToAdd: courseIDsToAdd, StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove, AlternatesRank: alternatesRank });
            var alternateCoursesPromise = skyward.browse.get(alternateCourseBrowseName, skyward.browse.browseList[alternateCourseBrowseName].data, { CourseIDsToAdd: alternateCourseIDsToAdd, StudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove, AlternatesRank: alternatesRank });

            var beforeCloseCallback = function ()
            {
                resetMessages();
                hiddenContentContainer.append(contents); // Move contents back to hidden container
            };

            var deferredBeforeShowContent = $.Deferred();

            $.whenAll([selectedCoursesPromise, alternateCoursesPromise]).then(function ()
            {
                dialog.container.css("height", "95%");
                dialog.content.css("height", "100%");
                dialog.content.css("max-height", "92%");
                deferredBeforeShowContent.resolve();
            });

            var dialog = skyward.modalLayer.showDialog("My Requests", contents, [{ text: "Close", icon: "Close", click: "close" }], {
                beforeClose: beforeCloseCallback,
                beforeShowContentPromise: deferredBeforeShowContent
            });
        };

        var showMyRequestsButtonClick = function ()
        {
            resetMessages();
            showMyRequestsPopup();
        };

        var submitAndReviewButtonClick = function ()
        {
            showMyRequestsButtonClick();
            skyward.courserequest.submitCourseRequest();
        };

        skyward.courserequest.submitCourseRequest = function ()
        {
            resetMessages();

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/SubmitRequestedCourse" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    EntityID: entityID,
                    EntityID_SecurityHash: entityID_securityhash,
                    SchoolYearID: schoolYearID,
                    SchoolYearID_SecurityHash: schoolYearID_securityhash,
                    StudentID: studentID,
                    StudentID_SecurityHash: studentID_securityhash,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID,
                    AvailabilityFilterCourseStudentID_SecurityHash: availabilityFilterCourseStudentID_securityhash,
                    StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove,
                    StudentCourseRequestIDsToRemoveSecurityHash: studentCourseRequestIDsToRemoveSecurityHash,
                    CourseIDsToAdd: courseIDsToAdd,
                    CourseIDsToAddSecurityHash: courseIDsToAddSecurityHash,
                    AlternateStudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove,
                    AlternateStudentCourseRequestIDsToRemoveSecurityHash: alternateStudentCourseRequestIDsToRemoveSecurityHash,
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    AlternateCourseIDsToAddSecurityHash: alternateCourseIDsToAddSecurityHash,
                    AlternatesRank: alternatesRank
                },
                success: function (data)
                {
                    if (data.errormessage != "" && data.errormessage != null && data.errormessage != "undefined")
                    {
                        skyward.courserequest.showError(data.errormessage);
                        return;
                    }

                    skyward.courserequest.showConfirmation("The student course request changes have been successfully saved.");

                    updateInitialAlternateRank(data.alternatesRank);
                    clearStudentCourseRequestIDsToRemoveList();
                    clearCourseIDsToAddList();
                    showHideToolBarButtons();

                    skyward.browse.get(selectedCoursesBrowseName, skyward.browse.browseList[selectedCoursesBrowseName].data, { CourseIDsToAdd: courseIDsToAdd, StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove, AlternatesRank: alternatesRank });
                    if (skyward.browse.browseList[alternateCourseBrowseName])
                    {
                        skyward.browse.get(alternateCourseBrowseName, skyward.browse.browseList[alternateCourseBrowseName].data, { CourseIDsToAdd: alternateCourseIDsToAdd, StudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove, AlternatesRank: alternatesRank });
                    }
                    refreshSelectedBrowseTotals();
                }
            });
        };

        skyward.courserequest.cancel = function ()
        {
            resetMessages();
            clearStudentCourseRequestIDsToRemoveList();
            clearCourseIDsToAddList();
            skyward.browse.get(selectedCoursesBrowseName, skyward.browse.browseList[selectedCoursesBrowseName].data);
            if (skyward.browse.browseList[alternateCourseBrowseName])
            {
                skyward.browse.get(alternateCourseBrowseName, skyward.browse.browseList[alternateCourseBrowseName].data);
            }
            refreshSelectedBrowseTotals();
            resetAlternateRange(initialAlternateStudentCourseRequestRank);
            showHideToolBarButtons();
        };

        skyward.courserequest.reorder = function ()
        {
            var browse = skyward.browse.browseList[alternateCourseBrowseName];
            var table = reorderElement.find(".sortableWrapper table");
            table.empty();

            var arrowColumnWidth = 150;

            if (skyward.global.mobileAccess)
            {
                arrowColumnWidth = 90;
            }

            var tbody = $("<tbody class='ui-sortable' />");

            var tHeader = $("<tr class='sortableHeaderRow'>");
            tHeader.append("<td class='sortableTableColumnHeader' style='width: " + arrowColumnWidth + "px; '></td><td class='sortableTableColumnHeader'><div class='sortableEllipsizingText' style='width: 40px; '>Rank</div></td><td class='sortableTableColumnHeader'><div class='sortableEllipsizingText' style='width: 150px;'>Course Description</div></td><td class='sortableTableColumnHeader'><div class='sortableEllipsizingText' style='width: 85px; '>Course Code</div></td></tr>");
            tbody.append(tHeader);

            var arrowButtonsHTML = "<td style='width:" + arrowColumnWidth + "px; height:33px;'>" +
                "<a class='button sortableUp js-sortableUp' preserveAspectRatio='xMidYMid meet' focusable='false' tabindex='-1'>" +
                "<svg class='buttonSvg svg arrowUp svgGroup svgSortable' preserveAspectRatio='xMidYMid meet' focusable='false' tabindex='-1'>" +
                `<use xlink:href='${skyward.global.virtualDir}SkySys/Svg/spritesheet?v=3#svg-ArrowUp'></use></svg></a>` +
                "<a class='button sortableDown js-sortableDown svgAnchor' alt='Move Down' href='javascript:void(0)' tabindex='0'>" +
                "<svg class='buttonSvg svg arrowDown svgGroup svgSortable' preserveAspectRatio='xMidYMid meet' focusable='false' tabindex='-1'>" +
                `<use xlink:href='${skyward.global.virtualDir}SkySys/Svg/spritesheet?v=3#svg-ArrowDown'></use></svg></a ></td > `;

            var counter = 1;
            for (var idx = 0; idx < browse.rowData[courseIDName].length; idx++)
            {
                var courseID = browse.rowData[courseIDName][idx];
                var studentCourseRequestID = browse.rowData[studentCourseRequestIDName][idx];
                var courseCode = browse.rowData[courseCodeName][idx];
                var description = browse.rowData[courseDescriptionName][idx];
                var rowEvenOdd = (counter) % 2 == 0 ? "even" : "odd";

                var rowID = courseID + "-";
                if (studentCourseRequestID.indexOf("-") == -1)
                {
                    rowID += studentCourseRequestID;
                }

                var row = $("<tr class='sortableRow " + rowEvenOdd + "' data-id='" + rowID + "'/>");
                row.append($(arrowButtonsHTML));
                row.append($("<td class='sortColumn browseDataCell'><div style='width:" + reorderColumnWidths[0] + "px;' class='sortableEllipsizingText'>" + counter++ + "</div></td>"));
                row.append($("<td class='browseDataCell'><div style='width:" + reorderColumnWidths[1] + "px;' class='sortableEllipsizingText'>" + description + "</div></td>"));
                row.append($("<td class='browseDataCell'><div style='width:" + reorderColumnWidths[2] + "px;' class='sortableEllipsizingText'>" + courseCode + "</div></td>"));
                tbody.append(row);
            }

            table.append(tbody);

            skyward.sortable.initialize(reorderElement.html(), "Scheduling", "StudentCourseRequest", {}, skyward.courserequest.saveOrder);
        };

        skyward.courserequest.saveOrder = function (messageBox)
        {
            var list = [];
            $sortable = messageBox.content.find(".sortable").first();
            $sortable.find("tbody tr").each(function (index, element)
            {
                var id = $(element).data('id');
                list.push($(element).data('id'));
            });

            messageBox.close();

            if (list.length > 0)
            {
                updateAlternateRank(JSON.stringify(list));
                skyward.browse.get(alternateCourseBrowseName, skyward.browse.browseList[alternateCourseBrowseName].data, { CourseIDsToAdd: alternateCourseIDsToAdd, StudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove, AlternatesRank: alternatesRank });
                showHideToolBarButtons();
            }
        };

        var updateAlternateRank = function (ranks)
        {
            resetAlternateRange(ranks);
        };

        var updateInitialAlternateRank = function (newRank)
        {
            initialAlternateStudentCourseRequestRank = newRank;
            resetAlternateRange(initialAlternateStudentCourseRequestRank);
        };

        var resetAlternateRange = function (ranks)
        {
            alternatesRank = ranks;
        };

        var refreshSelectedBrowseTotals = function ()
        {
            displayHighestMaximumCredits();
            updateTotalEarnedCreditsAndCounts();
        };

        var setRequestOrCreditsText = function (selector, valueToSet)
        {
            var control = $(selector);
            if (control.is(":input"))
            {
                control.val(valueToSet);
            }
            else
            {
                control.text(valueToSet);
            }
        };

        var getRequestOrCreditsValue = function (selector)
        {
            var control = $(selector).eq(0);
            if (control.is(":input"))
            {
                return skyward.controls.getValue(control);
            }
            else
            {
                return control.text();
            }
        }

        var displayHighestMaximumCredits = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/GetHighestMaximumCreditValues" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    StudentID: studentID,
                    EntityID: entityID,
                    SchoolYearID: schoolYearID,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        useCreditsMaximum = data.UseCreditsMaximum;
                        useCourseRequestCountMaximum = data.UseCourseRequestCountMaximum;

                        if (data.UseCreditsMaximum)
                        {
                            if (data.MaximumCredits != "")
                            {
                                setRequestOrCreditsText(maximumCredits, data.MaximumCredits);
                            }
                            if (data.MaximumAlternateCredits != "")
                            {
                                setRequestOrCreditsText(maximumAlternateCredits, data.MaximumAlternateCredits);
                            }
                        }
                        else
                        {
                            $(maximumCredits).parent().hide();
                            $(maximumAlternateCredits).parent().hide();
                        }

                        if (data.UseCourseRequestCountMaximum)
                        {
                            if (data.MaximumCourseRequests != "")
                            {
                                setRequestOrCreditsText(maximumCourseRequests, data.MaximumCourseRequests);
                            }
                            if (data.MaximumAlternateCourseRequests != "")
                            {
                                setRequestOrCreditsText(maximumAlternateCourseRequests, data.MaximumAlternateCourseRequests);
                            }
                        }
                        else
                        {
                            $(maximumCourseRequests).parent().hide();
                            $(maximumAlternateCourseRequests).parent().hide();
                        }
                    }
                }
            });
        };

        var updateTotalEarnedCreditsAndCounts = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/GetTotalEarnedCredits" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    StudentID: studentID,
                    EntityID: entityID,
                    SchoolYearID: schoolYearID
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        if (data.TotalEarnedCredits != "")
                        {
                            setRequestOrCreditsText(totalEarnedCredits, data.TotalEarnedCredits);
                        }

                        if (data.TotalAlternateEarnedCredits != "")
                        {
                            setRequestOrCreditsText(totalAlternateEarnedCredits, data.TotalAlternateEarnedCredits);
                        }

                        if (data.TotalRequests != "")
                        {
                            setRequestOrCreditsText(totalRequests, data.TotalRequests);
                        }

                        if (data.TotalAlternateRequests != "")
                        {
                            setRequestOrCreditsText(totalAlternateRequests, data.TotalAlternateRequests);
                        }
                    }
                }
            });
        };

        var showHideToolBarButtons = function ()
        {
            var dirtyClassName = "dirty";
            var changeClassName = "change ";

            if ((courseIDsToAdd != "" && courseIDsToAdd != null && courseIDsToAdd != "undefined") ||
                (studentCourseRequestIDsToRemove != "" && studentCourseRequestIDsToRemove != null && studentCourseRequestIDsToRemove != "undefined") ||
                (alternateCourseIDsToAdd != "" && alternateCourseIDsToAdd != null && alternateCourseIDsToAdd != "undefined") ||
                (alternateStudentCourseRequestIDsToRemove != "" && alternateStudentCourseRequestIDsToRemove != null && alternateStudentCourseRequestIDsToRemove != "undefined") ||
                alternatesRank != initialAlternateStudentCourseRequestRank)
            {
                updateSubmitButtonDisplay(changeClassName, dirtyClassName);
                updateCancelButtonDisplay(changeClassName, dirtyClassName);
                skyward.changeTracking.overrideGlobalDirtyState(true);
            }
            else
            {
                updateSubmitButtonDisplay(dirtyClassName, changeClassName);
                updateCancelButtonDisplay(dirtyClassName, changeClassName);
                skyward.changeTracking.overrideGlobalDirtyState(false);
            }

            if (!skyward.global.mobileAccess)
            {
                searchFocusAndSelectText();
            }
        };

        var updateSubmitButtonDisplay = function (removeClass, addClass)
        {
            submitButton.removeClass(removeClass);
            submitButton.addClass(addClass);
        };

        var updateCancelButtonDisplay = function (removeClass, addClass)
        {
            cancelButton.removeClass(removeClass);
            cancelButton.addClass(addClass);
        };

        //helper functions
        var clearStudentCourseRequestIDsToRemoveList = function ()
        {
            studentCourseRequestIDsToRemove = "";
            studentCourseRequestIDsToRemoveSecurityHash = "";
            alternateStudentCourseRequestIDsToRemove = "";
            alternateStudentCourseRequestIDsToRemoveSecurityHash = "";
        };

        var clearCourseIDsToAddList = function ()
        {
            courseIDsToAdd = "";
            courseIDsToAddSecurityHash = "";
            alternateCourseIDsToAdd = "";
            alternateCourseIDsToAddSecurityHash = "";
        };

        var updateStudentCourseRequestIDsToRemoveList = function (courses, coursesHash)
        {
            if (courses == null || courses == "undefined")
            {
                clearStudentCourseRequestIDsToRemoveList();
            }
            else
            {
                if (isAlternateMode)
                {
                    alternateStudentCourseRequestIDsToRemove = courses;
                    alternateStudentCourseRequestIDsToRemoveSecurityHash = coursesHash;
                }
                else
                {
                    studentCourseRequestIDsToRemove = courses;
                    studentCourseRequestIDsToRemoveSecurityHash = coursesHash;
                }
            }
        };

        var updateCourseIDsToAddList = function (courses, coursesHash)
        {
            if (courses == null || courses == "undefined")
            {
                clearCourseIDsToAddList();
            }
            else
            {
                if (isAlternateMode)
                {
                    alternateCourseIDsToAdd = courses;
                    alternateCourseIDsToAddSecurityHash = coursesHash;
                }
                else
                {
                    courseIDsToAdd = courses;
                    courseIDsToAddSecurityHash = coursesHash;
                }
            }
        };

        var getSelectedBrowseRowPrimaryKey = function (browse)
        {
            if (browse.currentRow == undefined && browse.currentRow == null)
            {
                return null;
            }

            return browse.primaryKeys[browse.currentRow];
        };

        var getSelectedBrowseRowData = function (browse, key)
        {
            if (browse.currentRow == undefined && browse.currentRow == null)
            {
                return null;
            }

            return browse.rowData[key][browse.currentRow];
        };

        var IsAddedByOffice = function (requestSource)
        {
            if (requestSource == null || requestSource == "undefined")
            {
                return false;
            }

            if (requestSource.toLowerCase() === "o")
            {
                return true;
            }

            return false;
        };

        var IsAddedByRecommendation = function (requestSource)
        {
            if (requestSource == null || requestSource == "undefined")
            {
                return false;
            }

            if (requestSource.toLowerCase() === "r")
            {
                return true;
            }

            return false;
        };

        var IsAddedByImport = function (requestSource)
        {
            if (requestSource == null || requestSource == "undefined")
            {
                return false;
            }

            if (requestSource.toLowerCase() === "i")
            {
                return true;
            }

            return false;
        };

        var IsAddedByMassProcess = function (requestSource)
        {
            if (requestSource == null || requestSource == "undefined")
            {
                return false;
            }

            if (requestSource.toLowerCase() === "m")
            {
                return true;
            }

            return false;
        };

        var IsScheduled = function (requestStatus)
        {
            if (requestStatus == null || requestStatus == "undefined")
            {
                return false;
            }

            if (requestStatus.toLowerCase() === "s")
            {
                return true;
            }

            return false;
        };

        skyward.courserequest.generateCourseFilter = function (forceRefresh)
        {
            var availableCoursesContainsValue = $(availableCoursesContains);

            var containsValue = skyward.controls.getValue(availableCoursesContainsValue);

            if (containsValue != previousContainsString || forceRefresh)
            {
                if (containsValue != previousContainsString)
                {
                    previousContainsString = containsValue;
                }

                var postData = { CourseCodeContains: containsValue, DescriptionContains: containsValue, SubjectDescriptionContains: containsValue };

                if (skyward.global.mobileAccess)
                {
                    $.extend(postData, {
                        CourseIDsToAdd: JSON.stringify(JSON.parse(courseIDsToAdd || "[]")),
                        AlternateCourseIDsToAdd: JSON.stringify(JSON.parse(alternateCourseIDsToAdd || "[]")),
                        StudentCourseRequestIDsToRemove: combineStringifiedArrays(studentCourseRequestIDsToRemove, alternateStudentCourseRequestIDsToRemove),
                        AlternatesRank: alternatesRank
                    });
                }

                skyward.browse.get(availableCoursesBrowseName, skyward.browse.browseList[availableCoursesBrowseName].data, postData);
            }
        };

        var combineStringifiedArrays = function (array1, array2)
        {
            return JSON.stringify(JSON.parse(array1 || "[]").concat(JSON.parse(array2 || "[]")));
        };

        var tabClickHandler = function (event)
        {
            if (event.target.firstChild.data === isAlternateTabName)
            {
                isAlternateMode = true;
            }
            else
            {
                isAlternateMode = false;
            }

            showHideReorderButton();
        };

        var showHideReorderButton = function ()
        {
            if (skyward.global.mobileAccess)
            {
                // Reorder always shows on mobile
                return;
            }

            if (!isAlternateMode)
            {
                if (!reorderButton.hasClass('studentcourserequesthide'))
                {
                    reorderButton.addClass('studentcourserequesthide');
                }
            }
            else
            {
                reorderButton.removeClass('studentcourserequesthide');
            }
        };

        //Content Message Area -- cloned like code from skyward.ui.contentmessagearea.js
        skyward.courserequest.showConfirmation = function (message)
        {
            requestContentMessageArea.setConfirmationMessage(message);
            requestContentMessageArea.showConfirmation();
            myRequestsPopupRequestContentMessageArea.setConfirmationMessage(message);
            myRequestsPopupRequestContentMessageArea.showConfirmation();
        };

        skyward.courserequest.showInformation = function (message)
        {
            requestContentMessageArea.setInformationMessage(message);
            requestContentMessageArea.showInformation();
            myRequestsPopupRequestContentMessageArea.setInformationMessage(message);
            myRequestsPopupRequestContentMessageArea.showInformation();
        };

        skyward.courserequest.showError = function (message)
        {
            requestContentMessageArea.setErrorMessage(message);
            requestContentMessageArea.showError();
            myRequestsPopupRequestContentMessageArea.setErrorMessage(message);
            myRequestsPopupRequestContentMessageArea.showError();
        };

        skyward.courserequest.showWarning = function (message)
        {
            requestContentMessageArea.setWarningMessage(message);
            requestContentMessageArea.showWarning();
            myRequestsPopupRequestContentMessageArea.setWarningMessage(message);
            myRequestsPopupRequestContentMessageArea.showWarning();
        };

        var resetMessages = function ()
        {
            requestContentMessageArea.resetMessageContent(true, true, true);
            myRequestsPopupRequestContentMessageArea.resetMessageContent(true, true, true);
        };

        var contentMessageAreas = {};
        var currentContentMessageAreaKey = 0;

        skyward.courserequest.getContentMessageArea = function (container)
        {
            if (!container || !container.data())
            {
                return getStubbedContentMessageAreaObject();
            }

            var contentMessageAreaKey = container.data().contentMessageAreaKey;

            if (contentMessageAreaKey != undefined && contentMessageAreas.hasOwnProperty(contentMessageAreaKey))
            {
                return contentMessageAreas[contentMessageAreaKey];
            }

            var contentMessageArea = container.find('.contentMessageArea').first();

            if (contentMessageArea && contentMessageArea.length > 0)
            {
                var cmaObject = getContentMessageAreaObject(contentMessageArea);
                contentMessageAreas[currentContentMessageAreaKey] = cmaObject;
                container.data('content-message-area-key', currentContentMessageAreaKey);
                currentContentMessageAreaKey++;
                return cmaObject;
            }
            else
            {
                return null;
            }
        };

        /**
         * Returns an minimal object that mimics the structure of those returned by getContentMessageAreaObject
         */
        var getStubbedContentMessageAreaObject = function ()
        {
            var contentMessageAreaObject = {};
            contentMessageAreaObject.getContentMessageAreaElement = function ()
            {
                return $("<div>");
            };

            contentMessageAreaObject.resetConfirmation = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetError = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetInformation = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetWarning = function ()
            {
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.resetMessageContent = function ()
            {
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.setInformationMessage = function () { };
            contentMessageAreaObject.setConfirmationMessage = function () { };
            contentMessageAreaObject.setErrorMessage = function () { };
            contentMessageAreaObject.setWarningMessage = function () { };

            contentMessageAreaObject.showConfirmation = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showError = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showInformation = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showWarning = function ()
            {
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.height = function ()
            {
                return 0;
            };

            return contentMessageAreaObject;
        };

        var getContentMessageAreaObject = function (contentMessageAreaElement)
        {
            var contentMessageAreaObject = {};

            var contentMessageArea = contentMessageAreaElement;
            var errorMessage = getMessageObject(contentMessageArea, '.cmaErrorMessage');
            var warningMessage = getMessageObject(contentMessageArea, '.cmaWarningMessage');
            var confirmationMessage = getConfirmationMessageObject(contentMessageArea, '.cmaConfirmationMessage');
            var informationMessage = getMessageObject(contentMessageArea, '.cmaInformationMessage');

            contentMessageAreaObject.getContentMessageAreaElement = function ()
            {
                return contentMessageArea;
            };

            contentMessageAreaObject.resetConfirmation = function ()
            {
                confirmationMessage.reset();
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetError = function ()
            {
                errorMessage.reset();
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetInformation = function ()
            {
                informationMessage.reset();
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetWarning = function ()
            {
                warningMessage.reset();
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.resetMessageContent = function (isResetError, isResetWarning, isResetInformation)
            {
                if (isResetError)
                {
                    errorMessage.reset();
                }
                if (isResetWarning)
                {
                    warningMessage.reset();
                }
                if (isResetInformation)
                {
                    informationMessage.reset();
                }
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.setInformationMessage = function (message)
            {
                informationMessage.setMessage(message);
                informationMessage.show();
            };
            contentMessageAreaObject.setConfirmationMessage = function (message)
            {
                confirmationMessage.setMessage(message);
                confirmationMessage.show();
            };
            contentMessageAreaObject.setErrorMessage = function (message)
            {
                errorMessage.setMessage(message);
                errorMessage.show();
            };
            contentMessageAreaObject.setWarningMessage = function (message)
            {
                warningMessage.setMessage(message);
                warningMessage.show();
            };

            contentMessageAreaObject.showConfirmation = function ()
            {
                if (confirmationMessage.hasValue)
                {
                    confirmationMessage.show();
                }

                contentMessageArea.show();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showError = function ()
            {
                if (errorMessage.hasValue)
                {
                    errorMessage.show();
                }

                contentMessageArea.show();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showInformation = function ()
            {
                if (informationMessage.hasValue)
                {
                    informationMessage.show();
                }

                contentMessageArea.show();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showWarning = function ()
            {
                if (warningMessage.hasValue)
                {
                    warningMessage.show();
                }

                contentMessageArea.show();
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.height = function ()
            {
                return contentMessageArea.outerHeight(true);
            };

            return contentMessageAreaObject;
        };

        var getConfirmationMessageObject = function (contentMessageArea, className)
        {
            var messageObject = getBaseMessage();
            var messageElement = contentMessageArea.find(className);

            if (messageElement.length == 0)
            {
                // Try to fallback to message object higher up the DOM hierarchy
                messageElement = contentMessageArea.parent().find(className);

                if (messageElement.length == 0)
                {
                    return messageObject;
                }
            }

            messageElement.data('content-message-area-key', currentContentMessageAreaKey);
            messageObject.message = messageElement;
            var messageContainer = messageElement.find('.cmaMessage');
            messageObject.hasValue = messageElement.hasClass('cmaHasValue');

            messageObject = setConfirmationMessageFunctions(messageObject, messageContainer);

            messageObject.message.off('click');

            return messageObject;
        };

        var setConfirmationMessageFunctions = function (object, container)
        {
            var base =
            {
                makeHidden: object.makeHidden,
                show: object.show,
                hide: object.hide,
                isVisible: object.isVisible
            };

            object.hide = function ()
            {
                object.message.animate({ 'opacity': 0 },
                    {
                        complete: function ()
                        {
                            base.hide();
                        }
                    });
                return object;
            };
            object.show = function ()
            {
                base.show();
                object.message.animate({ 'opacity': 1 },
                    {
                        complete: function ()
                        {
                            window.setTimeout(function ()
                            {
                                object.reset();
                                container.trigger("SaveAnimationRedirect");
                            }, 3000);
                        }
                    });
                return object;
            };
            object.reset = function ()
            {
                object.hide();
                container.html('');
                object.message.removeClass('cmaHasValue');
                object.hasValue = false;
                return object;
            };
            object.setMessage = function (message)
            {
                var cmaMessage = container.find(".cmaMessageText");
                if (cmaMessage.length > 0)
                {
                    cmaMessage.text(message);
                }
                else
                {
                    container.text(message);
                }
                object.message.addClass('cmaHasValue');
                object.hasValue = true;
                return object;
            };

            return object;
        };

        var getMessageObject = function (contentMessageArea, className)
        {
            var messageObject = getBaseMessage();
            var messageElement = contentMessageArea.find(className);

            if (messageElement.length == 0)
            {
                return messageObject;
            }

            messageElement.data('content-message-area-key', currentContentMessageAreaKey);
            messageObject.message = messageElement;
            var messageContainer = messageElement.find('.cmaMessage');
            messageObject.hasValue = messageElement.hasClass('cmaHasValue');
            messageObject = setErrorWarningInformationFunction(messageObject, messageContainer);
            return messageObject;
        };

        var setErrorWarningInformationFunction = function (object, container)
        {
            object.reset = function ()
            {
                object.hide();
                container.html('');
                object.message.removeClass('cmaHasValue');
                object.hasValue = false;
                return object;
            };
            object.setMessage = function (message)
            {
                container.html(message);
                object.message.addClass('cmaHasValue');
                object.hasValue = true;
                return object;
            };

            setAdditionalInformationBubbleClick(object);
            return object;
        };

        var setAdditionalInformationBubbleClick = function (messageObject)
        {
            messageObject.message.off('click').click(function ()
            {
                var dialog = skyward.modalLayer.showDialog('Additional Information', messageObject.message.find('.cmaMessage').text(), [{ text: 'Close', icon: 'Close' }],
                    {
                        anchorTo: messageObject.message.find('.svg')
                    });
            });
        };

        var getBaseMessage = function ()
        {
            var baseMessage = {};

            baseMessage.message = undefined;

            baseMessage.show = function ()
            {
                if (baseMessage.message)
                {
                    baseMessage.message.removeClass('cmaHidden');
                }
                return baseMessage;
            };

            baseMessage.hide = function ()
            {
                if (baseMessage.message)
                {
                    baseMessage.message.addClass('cmaHidden');
                }
                return baseMessage;
            };

            baseMessage.reset = function ()
            {
                return baseMessage.hide();
            };

            return baseMessage;
        };

        skyward.courserequest.showLegend = function (button)
        {
            skyward.modalLayer.showDialog("Course Requests Legend", $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/OnlineRequestsGetLegend",
                type: "GET",
                dataType: "viewparthtml"
            }), [{ text: "Close", icon: "Close", click: "close" }], { anchorTo: $(button) });
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
)